import * as React from "react";
import {Loan} from "Loans/interface";
import {connect} from "react-redux";
import './styles.scss';

interface IConnectProps {
  loanIndex: number;
  loanList: Loan[];
}

export interface SoaTransaction {
  amount: string;
  date: number;
  narration: string;
  balance: string;
  sl_no: number;
}

const TransactionDetails = (props: IConnectProps) => {
  const txns:SoaTransaction[] = props.loanList[props.loanIndex].state['soa_txns'].reverse();
  return (
    <div className="transc-container">
      <h2 className="transc-heading">Recent Transaction</h2>
      <div className="transc-details-container">
        {
          txns.map((txn: SoaTransaction, index: number) =>
            <div className="transc-details" key={index}>
              <div>
                <p className="transc-type">{txn.narration}</p>
                <p className="transc-date">
                  {`${new Date(Number(txn.date) - new Date().getTimezoneOffset() * 60000).toUTCString().slice(4, 25)}`}
                </p>
              </div>
              <p className={`transc-amount ${Number(txn.amount) < 0 ? 'draw': 'pay'}`}>
              {`${Number(txn.amount) < 0 ? '-' : '+'} ₹${Math.abs(Number(txn.amount))}`}
              </p>
            </div>
          )
        }
      </div>
    </div>
  );
};

const mapStateToProps = (state): IConnectProps => {
  return {
      loanIndex: state.loanDetails['loanIndex'],
      loanList: state.loanDetails['loansList'] ? state.loanDetails['loansList']: [],
  };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(TransactionDetails);